import React from 'react'

import { fabric } from 'fabric';

import { Canvas, ICanvas } from '~/components/Canvas';
import { useCanvas } from '~/contexts/CanvasContext';
import {
  useCursor,
  useDeleteSelection,
  useDrawAnnotation,
  useEraser,
  useImage,
  useRectangleAnnotation,
  useSelection,
  useTextAnnotation,
} from '~/hooks/useFabric';

interface IImageAnnotation extends ICanvas {
  src?: string;
  aspectRatio: number;
  zoomed?: boolean;
  children?: React.ReactNode;
}

export const ImageAnnotation = React.memo(React.forwardRef<fabric.Canvas, IImageAnnotation>(
  function ImageAnnotation(props, ref: React.MutableRefObject<fabric.Canvas>) {
    const { src, aspectRatio, zoomed = true, children, ...others } = props;
    const context = useCanvas();

    useSelection({
      ref,
      context,
    });

    useCursor({
      ref,
      context,
      defaultCursor: 'default',
    });

    useImage({
      ref,
      src,
      aspectRatio,
    });

    useRectangleAnnotation({
      ref,
      context,
      zoomed,
    });

    useDrawAnnotation({
      ref,
      context,
      zoomed,
    });

    useTextAnnotation({
      ref,
      context,
      zoomed,
    });

    useEraser({
      ref,
      context,
    });

    useDeleteSelection({
      ref,
      context,
    });

    return (
      <Canvas ref={ref} {...others}>
        {children}
      </Canvas>
    );
  }
));
